import { render } from "./Loading.vue?vue&type=template&id=33030c78&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=33030c78&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33030c78"]])

export default __exports__